/**
 * Etiquetas legibles del catálogo de eventos frontera (REQ-FRT-015).
 *
 * `frontier.run.failed` → `frontier.events.types.run_failed`; si la clave no
 * existe se devuelve el tipo crudo (fallback explícito, nunca una clave i18n
 * a medias). Compartido por la vista Eventos y el detalle de ejecución.
 */
export function frontierEventLabel(
  t: (key: string) => string,
  type: string,
): string {
  const key = `frontier.events.types.${type.replace(/^frontier\./, '').replace(/\./g, '_')}`;
  const label = t(key);
  return label === key ? type : label;
}
